import React from "react";
import { Link, useLocation } from "react-router-dom";
import { X } from 'lucide-react'; // Optional icon
import logo from '../../assets/logo.svg'


const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const abc = searchParams.get('abc');
  const xyz = searchParams.get('xyz');
  
  // Create URL with current query parameters
  const createUrl = (path) => {
    const params = new URLSearchParams();
    if (abc) params.set('abc', abc);
    if (xyz) params.set('xyz', xyz);
    return `${path}?${params.toString()}`;
  };
    return (
        <div className="bg-gray-800 text-white flex flex-col">
            <div
                className={`fixed top-0 left-0 h-full w-64 bg-gray-800 px-2 shadow-lg z-40 transform transition-transform duration-300 ${isOpen ? 'translate-x-0' : '-translate-x-full'
                    }`}
            >
                <div className="flex items-center justify-between px-4 py-6">
                    <h2 className="text-xl font-bold"><img src={logo} alt="Game Gems" title="Game Gems" className="h-6" /></h2>
                    <button onClick={toggleSidebar}>
                        <X className="h-6 w-6" />
                    </button>
                </div>
                <ul className="space-y-4 px-3">
                    {/* <li><Link to="/test" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Test</Link></li> */}
                    <li><Link to={createUrl('/game-list')} className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Game List</Link></li>
                    <li><Link to={createUrl('/transaction-history')} className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Transaction History</Link></li>
                    {/* <li><Link to="/announcement" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Announcement</Link></li> */}
                    {/* <li><Link to="/weekly-leaderboard" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Weekly Leaderboard</Link></li>
                <li><Link to="/pioneer-list" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Pioneer List</Link></li>*/}
                    {/* <li><Link to="/notifications" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Notification</Link></li>
                    <li><Link to="/settings" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Settings</Link></li> */}
                </ul>
            </div>

        </div>
    );
};


export default Sidebar;